// extracted by mini-css-extract-plugin
export default {"switcher":"V4uA9","switcherButton":"-6IUc","oneStep":"oHygR"};